import {useEffect, useState} from 'react'
import styled, {keyframes} from 'styled-components'
import userIcon from '../assets/guru.png'
import schiefIcon from '../assets/schiefIcon.svg'

const spin = keyframes`
      0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

const Spinner = styled.div`
    position: fixed;
    top: 40%;
    z-index: 99999;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    width: 50px;
    height: 50px;

    &::after {
        content: ' ';
        display: block;
        width: 34px;
        height: 34px;
        margin: 8px;
        border-radius: 50%;
        border: 6.4px solid currentColor;
        border-color: currentColor transparent currentColor transparent;
        animation: ${spin} 1.2s linear infinite;
    }
`
const dotsAnimation = keyframes`
    0% {
        content: '';
    }
    33% {
        content: '.';
    }
    66% {
        content: '..';
    }
    100% {
        content: '...';
    }
`

const LoadingContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 20px;
    margin-left: 20px;
    & img {
        width: 44px;
        height: 44px;
        margin-right: 10px;
    }

    & p {
        margin: 0;
        font-size: 17px;
    }

    & span {
        font-size: 17px;
        font-weight: bold;
        color: green;
        display: inline-block;

        &::after {
            content: '...';
            animation: ${dotsAnimation} 1.5s infinite;
        }
    }
`

export const useLoading = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [loadingMessage, setLoadingMessage] = useState<string>(
        'Consultando banco de dados'
    )

    useEffect(() => {
        const messages = [
            'Consultando banco de dados',
            'Filtrando documentos',
            'Gerando resposta com IA',
        ]
        let currentIndex = 0

        const intervalId = setInterval(() => {
            currentIndex = (currentIndex + 1) % messages.length
            setLoadingMessage(messages[currentIndex])
        }, 1500)

        return () => clearInterval(intervalId)
    }, [])

    function LoadingMessage() {
        return (
            <LoadingContainer>
                <img
                    src={
                        window.location.hostname.includes('procon')
                            ? schiefIcon
                            : userIcon
                    }
                    alt="Ícone de usuário"
                />
                <p>{loadingMessage}</p>
                <span style={{marginLeft: '10px'}}></span>
            </LoadingContainer>
        )
    }

    return {
        Spinner: isLoading ? LoadingSpinner : Empty,
        LoadingMessage: isLoading ? LoadingMessage : Empty,
        isLoading,
        setIsLoading,
    }
}

const LoadingSpinner = () => {
    return <Spinner></Spinner>
}

const LoadingMessage = () => {
    return <LoadingMessage />
}

const Empty = () => {
    return <></>
}
